import React from "react";
import { getValidLandingScreen } from "../../../helpers/utils";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { downloadPreAssessmentCSV } from "../../../slices/Admin/preAssessments.slice";
import { showSuccess } from "../../../helpers/Notifications/Notification";
import { Button } from "../../../components/ds";

const ControlLibraryHeader = ({
  isAdminView,
  isPlatformAdminView,
  handleDrawerOpen,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isCsvDownloading } = useSelector((state) => state.preAssessment);

  const handleCsvDownload = () => {
    dispatch(
      downloadPreAssessmentCSV(() => {
        showSuccess("CSV downloaded successfully");
      })
    );
  };

  return (
    <div className="list-header">
      {!isPlatformAdminView && (
        <div className="list-title">
          {!isAdminView && (
            <span
              className="left-arrow"
              onClick={() => history.push(getValidLandingScreen())}
            >
              <ArrowLeftOutlined />
            </span>
          )}{" "}
          Control Library
        </div>
      )}
      {isAdminView && (
        <div className="header-options" style={{ gap: 7 }}>
          <Button
            variant="secondary"
            onClick={handleCsvDownload}
            disabled={isCsvDownloading}
            title="Pre-assessment Report (CSV)"
          >
            {isCsvDownloading ? "DOWNLOADING" : "DOWNLOAD CSV"}
          </Button>
          <Button
            onClick={() => handleDrawerOpen([])}
            title="ADD LINK"
          >
            ADD <span className="hidden-text">LINK</span>
          </Button>
        </div>
      )}
    </div>
  );
};

export default ControlLibraryHeader;
